import request from '../utils/request'

/**
 * 用户相关接口
 */

// 获取用户信息
export function getUserInfo() {
  return request({
    url: '/h5/user/info',
    method: 'get'
  })
}

// 更新用户信息
export function updateUserInfo(data) {
  return request({
    url: '/h5/user/info',
    method: 'put',
    data
  })
}

// 获取邀请信息
export function getInviteInfo() {
  return request({
    url: '/h5/user/invite',
    method: 'get'
  })
}

// 公开获取用户邀请二维码（不需要登录，分享落地页用）
export function getInviteInfoPublic(userId) {
  return request({
    url: `/h5/user/invite/${userId}`,
    method: 'get'
  })
}

// 获取我的统计数据
export function getMineStats() {
  return request({
    url: '/h5/user/stats',
    method: 'get'
  })
}

// 推荐好友购买统计（按时间范围）
export function getReferrerStats(startTime, endTime) {
  return request({
    url: '/h5/user/referrer-stats',
    method: 'get',
    params: { startTime, endTime }
  })
}

// 获取我推荐的好友列表
export function getReferrerList() {
  return request({
    url: '/h5/user/referrer-list',
    method: 'get'
  })
}

// 设置/取消团队骨干
export function setBackbone(friendId, isBackbone) {
  return request({
    url: '/h5/user/set-backbone',
    method: 'post',
    data: { friendId, isBackbone }
  })
}

// 获取骨干推荐码信息
export function getBackboneInfo() {
  return request({
    url: '/h5/user/backbone-info',
    method: 'get'
  })
}

// 公开获取骨干推荐码（分享落地页用）
export function getBackboneInfoPublic(userId) {
  return request({
    url: `/h5/user/backbone-invite/${userId}`,
    method: 'get'
  })
}
